// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorBoundary_errorPage__NyYgB","errorText":"ErrorBoundary_errorText__6ABRH"};